import { fetchRequestWithTypes } from './index.js';

export const POST_PARTY_CLAIM_REQUEST = 'POST_PARTY_CLAIM_REQUEST';
export const POST_PARTY_CLAIM_SUCCESS = 'POST_PARTY_CLAIM_SUCCESS';
export const POST_PARTY_CLAIM_ERROR = 'POST_PARTY_CLAIM_ERROR';

export const SET_STOCK_PARTY_POST_CLAIM_COMPLETE = 'SET_STOCK_PARTY_POST_CLAIM_COMPLETE';

export const SET_STOCK_PARTY_PRE_CLAIM_COMPLETE = 'SET_STOCK_PARTY_PRE_CLAIM_COMPLETE';

export const SET_STOCK_PARTY_STATUS_COMPLETE = 'SET_STOCK_PARTY_STATUS_COMPLETE';

export const GET_CURRENT_OR_NEXT_PARTY_REQUEST = 'GET_CURRENT_OR_NEXT_PARTY_REQUEST';
export const GET_CURRENT_OR_NEXT_PARTY_SUCCESS = 'GET_CURRENT_OR_NEXT_PARTY_SUCCESS';
export const GET_CURRENT_OR_NEXT_PARTY_ERROR = 'GET_CURRENT_OR_NEXT_PARTY_ERROR';

export const GET_REFERRAL_DETAILS_REQUEST = 'GET_REFERRAL_DETAILS_REQUEST';
export const GET_REFERRAL_DETAILS_SUCCESS = 'GET_REFERRAL_DETAILS_SUCCESS';
export const GET_REFERRAL_DETAILS_ERROR = 'GET_REFERRAL_DETAILS_ERROR';

export const getCurrentOrNextParty = () =>
	fetchRequestWithTypes({
		types: [
			GET_CURRENT_OR_NEXT_PARTY_REQUEST,
			GET_CURRENT_OR_NEXT_PARTY_SUCCESS,
			GET_CURRENT_OR_NEXT_PARTY_ERROR,
		],
		request: {
			method: 'GET',
			path: '/party/api/v1/parties/last-and-current-or-next',
		},
	});

export const postPartyClaim = (partyId, userId) =>
	fetchRequestWithTypes({
		types: [POST_PARTY_CLAIM_REQUEST, POST_PARTY_CLAIM_SUCCESS, POST_PARTY_CLAIM_ERROR],
		request: {
			method: 'POST',
			path: `/party/api/v1/parties/${partyId}/claims`,
			body: {
				user_id: userId,
			},
		},
	});

export const setStockPartyPostClaimComplete = () => ({
	type: SET_STOCK_PARTY_POST_CLAIM_COMPLETE,
});

export const setStockPartyPreClaimComplete = () => ({
	type: SET_STOCK_PARTY_PRE_CLAIM_COMPLETE,
});

export const setStockPartyStatusComplete = () => ({
	type: SET_STOCK_PARTY_STATUS_COMPLETE,
});

export const getReferralDetails = (promoCode) => {
	if (!promoCode) {
		return { type: GET_REFERRAL_DETAILS_ERROR, error: 'Missing referral code' };
	}
	return fetchRequestWithTypes({
		types: [GET_REFERRAL_DETAILS_REQUEST, GET_REFERRAL_DETAILS_SUCCESS, GET_REFERRAL_DETAILS_ERROR],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/promotions/referrals/codes/details?referralCode=${encodeURIComponent(
				promoCode
			)}`,
		},
	});
};
